import React from 'react';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import BulkFileUpload from './BulkFileUpload';
import { selectBulkAutoSubmit } from '@/redux/selectors/bulkSearchSelectors';
import Toggle from '@/components/_common/Toggle/Toggle';
import OPOrderStepperButtons from '../../OPOrderStepperButtons';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { useFormikContext } from 'formik';
import { toggleAutoSubmit } from '@/redux/slices/bulkSearchSlice';
import { findandFormatUTCDateInString } from '@/_utils/date';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';

const Step2BulkSearch = () => {
  const dispatch = useAppDispatch();
  const autoSubmit = useAppSelector(selectBulkAutoSubmit);
  const { values }: { values: any } = useFormikContext();

  return (
    <div>
      <BulkTitle>
        <Typography variant="h2">Bulk Order</Typography>
        <PolarisIcon icon="right" height={25} width={25} />
        <Typography variant="h6">{findandFormatUTCDateInString(values.jobs[0].profile.name)}</Typography>
      </BulkTitle>
      <Body>
        <ToggleWrapper>
          <Toggle value={autoSubmit} onChange={() => dispatch(toggleAutoSubmit())} /> Auto-submit jobs
        </ToggleWrapper>
        <BulkFileUpload />
      </Body>
      <OPOrderStepperButtons />
    </div>
  );
};

export default Step2BulkSearch;

const Body = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacing(1)};
`;

const ToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  column-gap: ${({ theme }) => theme.spacing(1.5)};
  background: ${({ theme }) => theme.palette.primary.main + '2a'};
  padding-right: ${({ theme }) => theme.spacing(2.5)};
  height: 60px;
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  color: ${({ theme }) => (theme.palette.mode === 'dark' ? '#b5b4b4' : '#4a4a4a')};
`;

const BulkTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  column-gap: ${({ theme }) => theme.spacing(1)};

  h2 {
    margin-bottom: 5px;
  }

  h6 {
    opacity: 0.7;
    font-size: 1.5rem;
    font-weight: 400;
  }
`;
